import {ModalProps} from "react-bootstrap/Modal";
import {Button, Modal, ToggleButton} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions as websocket, IKettle, IKettleModeControl} from "../../store/sliceWebsocket";
import {
    ModalKettleButton,
    ModalKettleContainer, ModalKettleRange,
    ModalKettleSection,
    ModalKettleSectionHeader,
    ModalKettleSectionMode,
    ModalKettleSectionSettings,
    ModalKettleSectionTemperature,
    ModalKettleSectionTemperatureField,
    ModalKettleSectionTemperatureSubText,
    ModalKettleSectionTemperatureText
} from "./ModalKettleStyle";
import {kettleModeToText} from "../../utils/Util";
import RangeSlider from "react-bootstrap-range-slider";


const ModalKettle: FC<ModalProps> = (props) => {
    const {show} = props
    const dispatch = useDispatch<AppDispatch>();
    const kettle: IKettle = useSelector((state: IRootState) => state.websocket.kettle)
    const {boiling, heating, heatingHold, iqBoiling} = useSelector((state: IRootState) => state.websocket.kettleMode)
    const statusMode = useCallback((): string => {
        return kettleModeToText(kettle.mode, kettle.connection,  kettle.setPointTemperature)
    }, [kettle.mode, kettle.setPointTemperature, kettle.connection])

    const [setPointTempValue, setSetPointTempValue] = useState(0);

    useEffect(() => {
        setSetPointTempValue(kettle.saveSetPointTemperature)
    }, [kettle.saveSetPointTemperature])

    const statusTemperature = useCallback((): string => {
            if (!kettle.connection) {
                return "-- °C"
            } else {
                return `${kettle.temperature} °C`
            }

    }, [kettle.temperature, kettle.connection])

    const statusSetPointTemperature = useCallback((): string => {
        if (heating || heatingHold) {
            return `${setPointTempValue} °C`
        } else if (boiling || iqBoiling) {
            return `100 °C`
        }
        else {
            return `${kettle.setPointTemperature | setPointTempValue} °C`
        }


    }, [boiling, heating, heatingHold, iqBoiling, setPointTempValue, kettle.setPointTemperature,])

    const start = useCallback(() => {
        if (kettle.mode > 0) {
            dispatch(websocket.send({
                body: JSON.stringify({mode: 0}),
                topic: "/app/kettle.command"
            }))
            return
        }

        var command = {}

        if (boiling) {
            command = {mode: 1}
        }
        if (heating) {
            command = {mode: 3, setPointTemperature: setPointTempValue}
        }
        if (heatingHold) {
            command = {mode: 4, setPointTemperature: setPointTempValue}
        }
        if (iqBoiling) {
            command = {mode: 5}
        }
        dispatch(websocket.send({
            body: JSON.stringify(command),
            topic: "/app/kettle.command"
        }))
    }, [kettle.mode, boiling, heating, heatingHold, iqBoiling, setPointTempValue])

    const startName = useCallback((): string => {
        if (kettle.mode > 0) {
            return "Выключить"
        } else {
            return "Включить"
        }
    }, [kettle.mode])

    const setMode = (boiling: boolean, heating: boolean, heatingHold: boolean, iqBoiling: boolean) => {
        dispatch(websocket.setKettleMode({
            boiling: boiling,
            heating: heating,
            heatingHold: heatingHold,
            iqBoiling: iqBoiling,
        } as IKettleModeControl))
    }

    return (
        <Modal
            {...props}
            fullscreen={true}
            centered
        >
            <Modal.Header closeButton style={{gap: "10px"}}>Управление чайником</Modal.Header>
            <Modal.Body>
                <ModalKettleContainer>
                    <ModalKettleSectionTemperature>
                        <ModalKettleSectionTemperatureField>
                            <ModalKettleSectionTemperatureText>
                                {statusTemperature()}
                            </ModalKettleSectionTemperatureText>
                            <ModalKettleSectionTemperatureSubText>
                                Температура
                            </ModalKettleSectionTemperatureSubText>
                        </ModalKettleSectionTemperatureField>
                        <ModalKettleSectionTemperatureField>
                            {statusMode()}
                        </ModalKettleSectionTemperatureField>

                        <ModalKettleSectionTemperatureField>
                            <ModalKettleSectionTemperatureText>
                                {/*{kettle.setPointTemperature | setPointTempValue} °C*/}
                                {statusSetPointTemperature()}
                            </ModalKettleSectionTemperatureText>
                            <ModalKettleSectionTemperatureSubText>
                                Уставка
                            </ModalKettleSectionTemperatureSubText>
                        </ModalKettleSectionTemperatureField>

                    </ModalKettleSectionTemperature>
                    <ModalKettleSection>
                        <ModalKettleSectionHeader>Уставка температуры</ModalKettleSectionHeader>
                        <ModalKettleRange>
                        <RangeSlider
                            value={setPointTempValue}
                            onChange={changeEvent => setSetPointTempValue((Number(changeEvent.target.value)))}
                            min={35}
                            max={100}
                            step={5}
                            variant={"success"}
                            tooltip={"off"}
                            disabled={boiling || iqBoiling}
                        />
                        </ModalKettleRange>
                    </ModalKettleSection>

                    <ModalKettleSection>
                        <ModalKettleSectionHeader>Режимы</ModalKettleSectionHeader>

                        <ModalKettleSectionMode>
                            <ToggleButton
                                id="toggle-check-boiling"
                                type="checkbox"
                                variant="outline-success"
                                checked={boiling}
                                value="1"
                                onChange={() => {
                                    setMode(true, false, false, false)
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Кипячение</span>
                            </ToggleButton>
                            <ToggleButton
                                id="toggle-check-heating"
                                type="checkbox"
                                variant="outline-success"
                                checked={heating}
                                value="1"
                                onChange={() => {
                                    setMode(false, true, false, false)
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Разогрев</span>
                            </ToggleButton>
                            <ToggleButton
                                id="toggle-check-heatingHold"
                                type="checkbox"
                                variant="outline-success"
                                checked={heatingHold}
                                value="1"
                                onChange={() => {
                                    setMode(false, false, true, false)
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>Подогрев</span>
                            </ToggleButton>

                            <ToggleButton
                                id="toggle-check-iqBoiling"
                                type="checkbox"
                                variant="outline-success"
                                checked={iqBoiling}
                                value="1"
                                onChange={() => {
                                    setMode(false, false, false, true)
                                }}
                            >
                                {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                                <span>IQ Кипячение</span>
                            </ToggleButton>
                        </ModalKettleSectionMode>
                    </ModalKettleSection>

                    {/*<div style={{display: "flex", gap: "10px"}}>*/}
                    {/*<Button variant={"outline-success"} onClick={() => dispatch(websocket.send({*/}
                    {/*    body: JSON.stringify({mode: 1}),*/}
                    {/*    topic: "/app/kettle.command"*/}
                    {/*}))}> Включить</Button>*/}
                    {/*<Button variant={"outline-success"} onClick={() => dispatch(websocket.send({*/}
                    {/*    body: JSON.stringify({mode: 0}),*/}
                    {/*    topic: "/app/kettle.command"*/}
                    {/*}))}> Выключить</Button>*/}
                    {/*</div>*/}
                    <ModalKettleSection>
                        <ModalKettleSectionHeader>Настройки</ModalKettleSectionHeader>
                    <ModalKettleSectionSettings>
                        <ToggleButton
                            id="toggle-check-night"
                            type="checkbox"
                            variant="outline-success"
                            checked={kettle.night}
                            value="1"
                            onChange={() => dispatch(websocket.send({
                                body: JSON.stringify({night: !kettle.night}),
                                topic: "/app/kettle.command"
                            }))}
                        >
                            {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                            <span>Ночной</span>
                        </ToggleButton>
                        <ToggleButton
                            id="toggle-check-backlight"
                            type="checkbox"
                            variant="outline-success"
                            checked={kettle.backlight}
                            value="1"
                            onChange={() => dispatch(websocket.send({
                                body: JSON.stringify({backlight: !kettle.backlight}),
                                topic: "/app/kettle.command"
                            }))}
                        >
                            {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                            <span>Подсветка</span>
                        </ToggleButton>
                        <ToggleButton
                            id="toggle-check-childLock"
                            type="checkbox"
                            variant="outline-success"
                            checked={kettle.childLock}
                            value="1"
                            onChange={() => dispatch(websocket.send({
                                body: JSON.stringify({childLock: !kettle.childLock}),
                                topic: "/app/kettle.command"
                            }))}
                        >
                            {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                            <span>Защита от детей</span>
                        </ToggleButton>
                        <ToggleButton
                            id="toggle-check-sound"
                            type="checkbox"
                            variant="outline-success"
                            checked={!kettle.sound}
                            value="1"
                            onChange={() => dispatch(websocket.send({
                                body: JSON.stringify({sound: !kettle.sound}),
                                topic: "/app/kettle.command"
                            }))}
                        >
                            {/*<JournalCheck style={{marginRight: "5px"}}/>*/}
                            <span>Беззвучный</span>
                        </ToggleButton>
                    </ModalKettleSectionSettings>
                    </ModalKettleSection>
                    <ModalKettleButton>
                        <Button style={{width: "100%"}} variant={"outline-success"} onClick={() => start()}>{startName()}</Button>
                    </ModalKettleButton>
                </ModalKettleContainer>

            </Modal.Body>
        </Modal>
    )
        ;
}

export default memo(ModalKettle)
